export default {
  // TITLE
  TitleControl: '',
  ShowTitleControl: { checked: true },
  StyleTitleControl: {
    fontSize: 20,
    color: '#000000',
    fontFamily: 'arial',
    bold: false,
    italic: false,
    underline: false,
    align: 'center',
  },
  // Drilldown
  DrilldownStyle: 'auto',
  // GENERAL
  SortValuesControl: 'Alfabética A-Z',
  CustomSortControl: {
    checked: false, kpiCategories: [],
  },
  // SortDDControl: 'auto',
  LayoutControl: 'vertical',
  ValueScaleControl: 'linear',
  PaddingControl: { value: 0.1 },
  InnerPaddingControl: { value: 5 },
  Margin: {
    top: 50,
    right: 145,
    bottom: 55,
    left: 60,
  },
  MinValueControl: { value: 0, checked: true },
  MaxValueControl: { value: 0, checked: true },
  DataAbsoluteFormat: 'number',
  DurationUnit: 'hours',
  // STYLE
  BorderRadiusControl: { value: 5 },
  BorderWidthControl: { value: 0 },
  BorderColorControl: { from: 'color', modifiers: [['darker', 1.6]] },
  MedianWidthControl: 2,
  MedianColorControl: { from: 'color', modifiers: [['darker', 0.3]] },
  WhiskerWidthControl: 2,
  WhiskerEndSizeControl: 0.6,
  WhiskerColorControl: { from: 'color', modifiers: [['darker', 0.3]] },
  PalletsControl: 'default',
  ColorTheme: { scheme: 'nivo' },
  GradientPickerControl: {
    color1: '#4711B2',
    color2: '#FF9626',
    color3: null,
  },
  Colors: {},
  // DDPalletsControl: 'auto',
  // DDColorTheme: { scheme: 'nivo' },
  // DDGradientPickerControl: {
  //   color1: '#4711B2',
  //   color2: '#FF9626',
  //   color3: null,
  // },
  UseGlobalColor: true,
  UseGlobalFont: true,
  // AXIS
  EnableGridX: false,
  EnableGridY: true,
  EnableAxisX: {
    axisTop: false,
    axisBot: true,
    maxLabelLines: 1,
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: '',
    legendOffset: 35,
    Decimals: 'auto',
    separadorNumericoCasasX: 0,
  },
  EnableAxisY: {
    axisLeft: true,
    axisRight: false,
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: '',
    legendOffset: -55,
    Decimals: 'auto',
    separadorNumericoCasasY: 0,
  },
  CurrencyControl: 'Nenhum',
  GroupingSelectControl: 'Nenhum',
  AxisGlobal: {
    fontSize: 12,
    fontFamily: 'arial',
    legendFontSize: 12,
    color: '#333333',
  },
  // LEGEND
  LegendControl: { checked: true },
  ColorByControl: 'auto',
  LegendPlacementControl: {
    value: {
      label: 'Direita',
      translateX: 110,
      translateY: 0,
      selectedPosition: 'right',
      direction: 'column',
      anchor: 'right',
    },
  },
  LegendsFontFamilyControl: { value: 'sans-serif' },
  LegendsFontSizeControl: { value: 12 },
  LegendBold: false,
  LegendItalic: false,
  LegendFontColor: '#999',
  LegendMaxLines: 1,
  LegendsSpacingControl: { value: 10 },
  LegendSymbolControl: 'circle',
  // TOOLTIP / INTERACTIVE
  InteractiveControl: true,
  InteractivePrefixControl: '',
  InteractiveSufixControl: '',
  InteractiveDecimals: 'auto',
  InteractiveSeparadorNumericoCasas: 0,
  InteractiveCurrencyControl: 'Nenhum',
  InteractiveGroupingControl: 'Nenhum',
  Animate: false,
  MotionConfig: 'default',
  // MARKER
  ShowMarkerControl: false,
  MarkersList: [],
};
